// eslint-disable-next-line no-unused-vars
import React from "react";
import { connect } from "react-redux";

import styles from "./FeedbackModal.module.scss";

import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";


const FeedbackModal = props => {

    return (
        <Modal
            className={styles.modal}
            setShowModal={props.setShowModal}
            
        >
            <div>
                <p className={styles["modal-heading"]}>Support</p>
                <div className={styles["modal-content"]}>
                    <iframe title="Feedback Form" className="freshwidget-embedded-form" id="freshwidget-embedded-form" src="https://compliancygroup.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded" scrolling="no" height="500px" width="100%" frameBorder="0" >
                    </iframe>
                </div>

                <div className={styles["modal-footer"]}>
                    <Button
                        text="CANCEL"
                        color="secondary"
                        onClick={() => props.setShowModal(false)}
                    />
                </div>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackModal);
